exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.arrangement{margin:2rem 0;text-align:center}div.arrangement img{display:block;margin:0 auto;width:100%;max-width:300px;cursor:pointer}", ""]);

// exports
